export default {
  methods: {
    mapLayerSignshopProductsalesandserviceAdd() {
      this.initPollSignshopProductsalesandservice();
      this.map.addSource("signshop-productsalesandservice-source", {
        type: "geojson",
        data: this.computedSignshopProductsalesandserviceGeoJson
      });

      // Good
      this.map.addLayer({
        filter: [
          "all",
          ["==", "condition", "Good"],
          ["in", "user_group", "Product Sales & Service"]
        ],
        id: "signshop-productsalesandservice-good",
        type: "circle",
        source: "signshop-productsalesandservice-source",
        paint: {
          "circle-radius": 4,
          "circle-color": "Green",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", "condition", "Poor"],
          ["in", "user_group", "Product Sales & Service"]
        ],
        id: "signshop-productsalesandservice-poor",
        type: "circle",
        source: "signshop-productsalesandservice-source",
        paint: {
          "circle-radius": 4,
          "circle-color": "Orange",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", "condition", "Damaged"],
          ["in", "user_group", "Product Sales & Service"]
        ],
        id: "signshop-productsalesandservice-damaged",
        type: "circle",
        source: "signshop-productsalesandservice-source",
        paint: {
          "circle-radius": 4,
          "circle-color": "Red",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", "condition", "Proposed"],
          ["in", "user_group", "Product Sales & Service"]
        ],
        id: "signshop-productsalesandservice-proposed",
        type: "circle",
        source: "signshop-productsalesandservice-source",
        paint: {
          "circle-radius": 4,
          "circle-color": "Pink",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", "condition", "Remove"],
          ["in", "user_group", "Product Sales & Service"]
        ],
        id: "signshop-productsalesandservice-remove",
        type: "circle",
        source: "signshop-productsalesandservice-source",
        paint: {
          "circle-radius": 4,
          "circle-color": "Black",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Red"
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", "condition", "Look At"],
          ["in", "user_group", "Product Sales & Service"]
        ],
        id: "signshop-productsalesandservice-lookat",
        type: "circle",
        source: "signshop-productsalesandservice-source",
        paint: {
          "circle-radius": 4,
          "circle-color": "Purple",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["!=", "condition", "Good"],
          ["!=", "condition", "Poor"],
          ["!=", "condition", "Damaged"],
          ["!=", "condition", "Proposed"],
          ["!=", "condition", "Remove"],
          ["!=", "condition", "Look At"],
          ["==", "user_group", "Product Sales & Service"]
        ],
        id: "signshop-productsalesandservice-other",
        type: "circle",
        source: "signshop-productsalesandservice-source",
        paint: {
          "circle-radius": 4,
          "circle-color": "Blue",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        }
      });

      this.map.addLayer({
        id: "signshop-productsalesandservice-labels",
        filter: ["all", ["in", "user_group", "Product Sales & Service"]],
        type: "symbol",
        source: "signshop-productsalesandservice-source",
        layout: {
          "text-field": "{struct_num}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [0.4, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"],
          visibility: "visible"
        },
        paint: {
          "text-color": "Black",
          "text-halo-color": "#fff",
          "text-halo-width": 2
        }
      });

      this.map.moveLayer(
        "signshop-productsalesandservice-labels",
        "marker-layer-points"
      );
      this.map.moveLayer(
        "signshop-productsalesandservice-good",
        "marker-layer-points"
      );
      this.map.moveLayer(
        "signshop-productsalesandservice-poor",
        "marker-layer-points"
      );
      this.map.moveLayer(
        "signshop-productsalesandservice-damaged",
        "marker-layer-points"
      );
      this.map.moveLayer(
        "signshop-productsalesandservice-proposed",
        "marker-layer-points"
      );
      this.map.moveLayer(
        "signshop-productsalesandservice-remove",
        "marker-layer-points"
      );
      this.map.moveLayer(
        "signshop-productsalesandservice-lookat",
        "marker-layer-points"
      );
      this.map.moveLayer(
        "signshop-productsalesandservice-other",
        "marker-layer-points"
      );
    },
    mapLayerSignshopProductsalesandserviceRemove() {
      this.cancelPollSignshopProductsalesandservice();
      this.map.removeLayer("signshop-productsalesandservice-labels");
      this.map.removeLayer("signshop-productsalesandservice-good");
      this.map.removeLayer("signshop-productsalesandservice-poor");
      this.map.removeLayer("signshop-productsalesandservice-damaged");
      this.map.removeLayer("signshop-productsalesandservice-proposed");
      this.map.removeLayer("signshop-productsalesandservice-remove");
      this.map.removeLayer("signshop-productsalesandservice-lookat");
      this.map.removeLayer("signshop-productsalesandservice-other");
      this.map.removeSource("signshop-productsalesandservice-source");
    },
    initPollSignshopProductsalesandservice() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/signshop/signage",
        dept: "signshop",
        layer: "productsalesandservice",
        token: this.computedAuthToken
      });
      this.pollSignshopProductsalesandserviceInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url: "https://api2.alchemymapping.com/vail/whistler/signshop/signage",
          dept: "signshop",
          layer: "productsalesandservice",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollSignshopProductsalesandservice() {
      this.pollSignshopProductsalesandserviceInterval = clearInterval(
        this.pollSignshopProductsalesandserviceInterval
      );
    }
  },
  computed: {
    computedSignshopProductsalesandserviceGeoJson() {
      return this.$store.state.mapLayers.signshop.layers.productsalesandservice
        .geojson;
    },
    computedSignshopProductsalesandserviceMapVisibility() {
      return this.$store.state.mapLayers.signshop.layers.productsalesandservice
        .visibility.mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.signshop.layers.productsalesandservice.geojson": {
      handler() {
        if (this.computedSignshopProductsalesandserviceGeoJson) {
          this.mapLayerSignshopProductsalesandserviceRemove();
          this.mapLayerSignshopProductsalesandserviceAdd();
        }
      }
    },
    "$store.state.mapLayers.signshop.layers.productsalesandservice.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerSignshopProductsalesandserviceAdd();
      } else {
        this.mapLayerSignshopProductsalesandserviceRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollSignshopProductsalesandservice();
  }
};
